// src/modules/app-views/_apps/appmulti/leads/pages/Document/actions/dropdownMenu.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { MoreOutlined } from '@ant-design/icons';
import {
  dropdownArchive,
  dropdownDivider,
  dropdownRemove,
  dropdownRemovePermanently,
  dropdownRestore,
} from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// DROPDOWN MENU
// Backup documentState.actions = ['reload','file','remove','permanently_remove']
// (new/edit/duplicate commented out) — mirrors orders viewer pattern.
// *******************************************************************************
const leadsDocumentDropdownMenu = () => ({
  action: 'dropdownMenu',
  icon: <MoreOutlined />,
  tooltip: 'more_options',
  dropdownItems: [
    dropdownDivider,
    dropdownArchive,
    dropdownRemove,
    dropdownRestore,
    dropdownRemovePermanently,
  ],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default leadsDocumentDropdownMenu;
